import React, { useState, useEffect } from "react";
import { ReactComponent as Dribble } from "../assets/icons/Social/dribbble.svg";
import { ReactComponent as Google } from "../assets/icons/Social/google.svg";
import { ReactComponent as Linkedin } from "../assets/icons/Social/linkedin.svg";
import { ReactComponent as Medium } from "../assets/icons/Social/medium.svg";
import { ReactComponent as Github } from "../assets/icons/Social/github.svg";
import { useViewportScroll, motion } from "framer-motion";
import Resume from "../assets/Resume_Sagar_Naik.pdf";

const socialIcons = [
  <Linkedin />,
  <Google />,
  <Dribble />,
  <Medium />,
  <Github />,
];

const socialLinks = [
  "https://www.linkedin.com/in/sagar-naik-8b0211197",
  "mailto: sagarnaikg00@gmail.com",
  "https://dribbble.com/Sagar_naik",
  "https://medium.com/@sagarnaikg",
  "https://github.com/Sagarnaikg",
];

const Contact = () => {
  const disableWidth = 880;
  const scrollFactor = 700;
  const { scrollYProgress } = useViewportScroll();

  const [y, setY] = useState(0);

  useEffect(() => {
    if (window.screen.width > disableWidth) {
      window.addEventListener("scroll", () => {
        setY(scrollYProgress.get() * scrollFactor);
      });
    }
  }, []);

  return (
    <div className="contact">
      <div className="container-fluid center">
        <div className="wrapper center">
          <div className="contact-subtitle subtitle">CONTACT</div>
          <motion.div
            style={window.screen.width < disableWidth ? {} : { y: -y + 670 }}
            className="contact-list"
          >
            {socialLinks.map((link, i) => (
              <motion.div
                whileHover={{ scale: 1.2 }}
                transition={{
                  duration: 0.2,
                  ease: "easeOut",
                }}
                className="contact-item"
                key={i}
              >
                <motion.div
                  initial={
                    window.screen.width < disableWidth ? { y: 0 } : { y: 100 }
                  }
                  whileInView={{ y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0.4,
                    delay: i / 25,
                    ease: "easeOut",
                  }}
                  className="contact-wrapper"
                >
                  <a href={link} target={"_blank"}>
                    {socialIcons[i]}
                  </a>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
        <div className="resume-text">
          <a href={Resume} download="Resume_Sagar_naik.pdf">
            Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
